import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import type { PropertyType } from '../../../core/models/property-type.model';
import type { Entity } from '../../../core/models/entity.model';
import type { UntypedFormGroup } from '@angular/forms';
import type { EntityEditorPropertyChangedEvent } from '../../models/entity-editor-property-changed.event';
import { PropertyComponentType, resolveComponentType } from '../../utils/property-helpers';
import type { PropertyEditorInputs } from '../../containers/property-editor-inputs';

@Component({
  selector: 'app-entity-property-editor',
  templateUrl: './entity-property-editor.component.html',
  styleUrls: ['./entity-property-editor.component.scss'],
  standalone: false
})
export class EntityPropertyEditorComponent implements PropertyEditorInputs, OnChanges {
  @Input() propertyType: PropertyType;
  @Input() entity: Entity;
  @Input() entityForm: UntypedFormGroup;
  @Input() placeholder: string;

  @Output() propertyChange = new EventEmitter<EntityEditorPropertyChangedEvent>();

  protected selectedComponent: PropertyComponentType;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['entity'] || changes['propertyType']) {
      this.selectedComponent = resolveComponentType(this.entity, this.propertyType);
    }
  }
}
